import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useAsync } from 'react-use';
import { transformToAbsoluteUrl } from '@uno/common-cms';
import { Stages } from '@uno/common-shared';
import { filterDisplayableUrls } from 'libs/content/utils';
import { getUrls } from 'redux/content';
import { getSeoData } from 'services/networking/seo';

var useSeoData = function useSeoData(dataTypes) {
  var _useSelector = useSelector(getUrls),
      urls = _useSelector.value,
      urlLoading = _useSelector.loading; // useRef for useAsync array dependencies to avoid infinite loop


  var _useRef = useRef(dataTypes),
      dataTypesRef = _useRef.current;

  var _useRef2 = useRef(urls),
      urlsRef = _useRef2.current;

  var _useAsync = useAsync( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _filterDisplayableUrl;

    var urlItem, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(urlsRef === undefined || urlsRef[0] === undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", undefined);

          case 2:
            urlItem = (_filterDisplayableUrl = filterDisplayableUrls(urlsRef)) === null || _filterDisplayableUrl === void 0 ? void 0 : _filterDisplayableUrl[0];

            if (!(urlItem === undefined)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", undefined);

          case 5:
            url = transformToAbsoluteUrl(_objectSpread(_objectSpread({}, urlItem), {}, {
              stage: Stages.PRODUCTION
            }));

            if (!(url !== undefined)) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return getSeoData(url, dataTypesRef);

          case 9:
            _context.t0 = _context.sent;
            _context.next = 13;
            break;

          case 12:
            _context.t0 = undefined;

          case 13:
            return _context.abrupt("return", _context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dataTypesRef, urlsRef]),
      seoDataLoading = _useAsync.loading,
      error = _useAsync.error,
      seoData = _useAsync.value;

  return {
    loading: seoDataLoading && urlLoading,
    error: error,
    value: seoData
  };
};

export default useSeoData;